export const LOG_UNHANDLED_EXCEPTION = 'LOG_UNHANDLED_EXCEPTION';

export const logUnhandledException = (exceptionType: any, err: any) =>
    ({ type: LOG_UNHANDLED_EXCEPTION, exceptionType, err });
